module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/apelv3-07b50c96eea5b243225d1d40c717f126.jpg";